<template>
<div class="container-fluid bg-white">
	<toolbar>
		<h2><i class="fa fa-tractor"></i> Contact Assets</h2>
		
		<div class="controls">

			<search-bar 
				placeholder="Search assets"
				v-model="searchTerms"
				v-on:submit="searchAssets"
				v-on:clearSearch="fetchAssets">
			</search-bar>

			<nav-tabs :tabs="[
					{
						icon: 'fa-project-diagram',
						label: 'Contacts',
						path: '/contacts'
					},
					{
						icon: 'fa-tractor',
						label: 'All Assets',
						path: '/contact-assets'
					}
				]"
				addon-apps-location="Contacts Module"
				addon-apps-link="/contacts/apps">
			</nav-tabs>
		</div>
	</toolbar>

	<collapsible-panel :external-toggle="filterPanelOpen" v-on:panelRetract="filterPanelOpen = false">
		<template slot="panel">
			<h4>Filtering</h4>

			<field label="Customer"
				col-class="stacked"
				:params="{type: 'select',options: customerOptions}"
				v-model="filtering.contact_id"
				v-on:change="fetchAssets(true)">
			</field>

			<field label="Serial #"
				col-class="stacked"
				:params="{type: 'text'}"
				v-model="filtering.serial_num"
				v-on:change="fetchAssets(true)">
			</field>

			<field label="Description"
				col-class="stacked"
				:params="{type: 'text'}"
				v-model="filtering.description"
				v-on:change="fetchAssets(true)">
			</field>

			<form-group label="Next Service"
				col-class="stacked">

				<div class="d-flex">
					<field :params="{type: 'select',options: [
						'Before','On','After'
					]}"
						v-model="filtering.nextServiceParam">
					</field>
					<field :params="{type: 'date'}"
						v-model="filtering.nextServiceDate"
						v-on:change="fetchAssets(true)">
					</field>
				</div>
			</form-group>

			<field label="Category"
				col-class="stacked"
				:params="{type:'select-multi',options:assetCategoriesOptions}"
				v-model="filtering.categories"
				v-on:change="fetchAssets(true)">
			</field>

		</template>
		<template slot="main">

			<table-list record-name="Asset"
				:fields="assetFields"
				:records="mutatedAssets"
				has-edit="/contact/asset/{?}/log"
				id-field="slug"
				:clickable-row="true"
				:sortable="true"
				edit-button-text="Open"
				:total-paginated-records="numResults"
				:loading="assetsLoading">

				<button type="button" class="btn btn-light" v-on:click="openFilterPanel" :disabled="filterPanelOpen">
					<i class="fa fa-filter"></i>
					Filter
				</button>

				<button class="btn btn-light ml-1" type="button" v-on:click="exportAssets">
					<i class="fa fa-download"></i>
					Export as CSV
				</button>

				<div v-if="searchTerms" class="mt-2">
					Showing results for search '{{searchTerms}}'
				</div>
			</table-list>

			<div class="text-center" v-if="mutatedAssets.length > 0 && numPages > page">
				<button class="btn btn-light" type="button" v-on:click="loadMore">
					Load More
				</button>
			</div>
		</template>
	</collapsible-panel>
</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"

import TableList from "@/components/TableList"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import SearchBar from "@/components/SearchBar"

export default {
	name: "CustomerAssetsMain",
	components: {
		Toolbar,
		NavTabs,
		TableList,
		CollapsiblePanel,
		Field,
		FormGroup,
		SearchBar
	},
	data() {
		return {
			filtering: {
				customer_id: null,
				serial_num: "",
				nextServiceParam: "On",
				nextServiceDate: null,
				categories: []
			},
			assets: [],
			page: 1,
			numPages: 0,
			numResults: 0,
			customers: [],
			assetFields: [
				{label: 'Category', key: 'categoryName'},
				{label: 'Customer', key: 'customerName'},
				{label: 'Description',key:'description'},
				{label: 'Serial #',key: 'serial_num'},
				{label: 'Customer Location',key: 'customerLocationName'},
				{label: 'Next Service',key:'next_service_date'}
			],
			assetCategories: [],
			searchTerms: "",
			filterPanelOpen: false,
			assetsLoading: false
		}
	},
	computed: {
		customerOptions() {
			return this.optionify(this.customers,"name")
		},
		assetCategoriesOptions() {
			return this.optionify(this.assetCategories,"name")
		},
		mutatedAssets() {
			return this.assets.map(asset => {
				asset.categoryName = ""
				if ("CustomerAssetCategory" in asset && asset.CustomerAssetCategory)
					asset.categoryName = asset.CustomerAssetCategory.name

				asset.customerName = ""
				if ("Contact" in asset && asset.Contact)
					asset.customerName = asset.Contact.name

				asset.customerLocationName = "Main"
				if ("ContactLocation" in asset && asset.ContactLocation) {
					if (asset.ContactLocation.location_name)
						asset.customerLocationName = asset.ContactLocation.location_name
					else
						asset.customerLocationName = asset.ContactLocation.address
				}

				return asset
			})
		}
	},
	methods: {
		openFilterPanel() {
			this.filterPanelOpen = true

			if (this.customers.length == 0) 
				this.fetchCustomers()
			if (this.assetCategories.length == 0)
				this.fetchAssetCategories()
		},
		exportAssets() {
			let vm = this

			let headerRow = this.assetFields.map(field => field.label)

			let rows = this.mutatedAssets.map(row => {
				let renderedRow = []

				vm.assetFields.forEach(field => {
					if (row[field.key] === null || row[field.key] === undefined)
						renderedRow.push("")

					else if (typeof(row[field.key]) == 'object') {
						if ('text' in row[field.key] && row[field.key].text)
							renderedRow.push(row[field.key].text)
						else
							renderedRow.push("")
					}

					else if (typeof(row[field.key]) == 'string' && row[field.key].includes("<i class=")) {
						let boolVal = row[field.key]
						if (row[field.key].includes("fa-times"))
							boolVal = false
						else if (row[field.key].includes("fa-check"))
							boolVal = true
						renderedRow.push(boolVal)

					} else {
						renderedRow.push(row[field.key])
					}
				})

				return renderedRow
			})

			this.exportToCSV("Assets.csv",[headerRow,...rows])
		},
		loadMore() {
			this.page++
			this.fetchAssets()
		},
		fetchCustomers() {
			let vm = this

			let params = {
				filters: [
					["is_customer",1]
				]
			}

			this.getJSON("Contact/get",params).then(response => {
				if (response.success)
					vm.customers = response.data
			})
		},
		fetchAssetCategories() {
			let vm = this

			this.getJSON("CustomerAssetCategory/get").then(response => {
				if (response.success)
					vm.assetCategories = response.data
			})
		},
		searchAssets(terms) {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {
					filters: [
						["description",terms,"and","like"],
						["serial_num",terms,"or","like"]
					],
					include: [
						{model: "Contact", fields: ["id","slug","name"]},
						{model: "CustomerAssetCategory", fields: ["id","slug","name"]},
						{model: "ContactLocation", fields: ["id","slug","location_name","suite","address","city","province"]}
					],
				}

				vm.spinner(true)

				vm.assetsLoading = true

				vm.getJSON("CustomerAsset/get",params).then(response => {
					vm.spinner(false)
					vm.assetsLoading = false

					if (response.success) 
						vm.assets = response.data

					resolve(response)
				})
			})
		},
		loadMore() {
			this.page++
			this.fetchAssets()
		},
		fetchAssets(resetPages) {
			let vm = this

			if (resetPages)
				this.page = 1

			this.$nextTick(() => {

				if (vm.page == 1)
					vm.assetsLoading = true

				let filters = []

				if (vm.filtering.contact_id > 0)
					filters.push(["contact_id",vm.filtering.contact_id])

				if (vm.filtering.serial_num) 
					filters.push(["serial_num",vm.filtering.serial_num,"and","like"])

				if (vm.filtering.nextServiceParam && vm.filtering.nextServiceDate) {
					let operand = ""
					if (vm.filtering.nextServiceParam == 'Before')
						operand = "<="
					else if (vm.filtering.nextServiceParam == 'After')
						operand = ">="

					filters.push(["next_service_date " + operand,vm.filtering.nextServiceDate])
				}

				if (vm.filtering.description)
					filters.push(["description",vm.filtering.description,"and","like"])

				if (vm.filtering.categories.length > 0)
					filters.push(["category_id",vm.filtering.categories])

				let params = {
					include: [
						{model: "Contact", fields: ["id","slug","name"]},
						{model: "CustomerAssetCategory", fields: ["id","slug","name"]},
						{model: "ContactLocation", fields: ["id","slug","location_name","suite","address","city","province"]}
					],
					filters,
					page: this.page
				}

				vm.spinner(true)

				vm.getJSON("CustomerAsset/get",params).then(response => {
					vm.assetsLoading = false

					vm.spinner(false)
					if (response.success) {
						vm.numPages = response.meta.num_pages
						vm.numResults = response.meta.num_results

						if (resetPages)
							vm.assets = response.data
						else
							vm.assets = [...vm.assets,...response.data]
					}
					
				})
			})
		}
	},
	created() {
		this.fetchAssets()
	}
}
</script>